import React from 'react';
import "react-dates/initialize";
import { DateRangePicker } from 'react-dates';

import DateRangeFilterOption from './date_range_filter_option.jsx';

import { ESCAPE, BACKSPACE, KEYDOWN, TAB, } from '../../../Shared/index'

const phrases = {
  chooseAvailableStartDate:({ date }) => `Choose ${date} as your start date. It’s available.`,
  chooseAvailableEndDate:({ date }) => `Choose ${date} as your end date. It’s available.`
}

const DateRangeFilter = ({ beginDate, dateFilterName, endDate, filterOptions, selectDates }) => {
  const [focusedInput, setFocusedInput] = React.useState(null);
  const containerRef = React.useRef(null);

  const closeOnKey = React.useCallback((e) => {
    if (e.key === ESCAPE || e.key === BACKSPACE) {
      setFocusedInput(null);
    }
    if (e.key === TAB) {
      setTimeout(() => {
        if (containerRef.current && !containerRef.current.contains(document.activeElement)) {
          setFocusedInput(null);
        }
      }, 0);
    }
  }, []);

  React.useEffect(() => {
    window.addEventListener(KEYDOWN, closeOnKey, true);
    return () => window.removeEventListener(KEYDOWN, closeOnKey, true);
  }, [closeOnKey]);

  const setDateFromFilter = (filter) => {
    setFocusedInput(null);
    selectDates(filter.beginDate, null, filter.title);
  };

  const renderFilterOptions = () => (
    <div className="calendar-prefill-options">
      {filterOptions.map((filter) => {
        const selected = dateFilterName === filter.title;
        return (
          <DateRangeFilterOption
            key={filter.title}
            onClickFunction={() => setDateFromFilter(filter)}
            selected={selected}
            title={filter.title}
          />
        );
      })}
    </div>
  );

  return (
    <div ref={containerRef}>
      <DateRangePicker
        customInputIcon={<img alt="" src={`${window.postbuildEnv.CDN_URL}/images/pages/activity_summary/calendar.svg`} />}
        daySize={30}
        endDate={endDate}
        endDateAriaLabel="Pick an end date to filter your student reports."
        endDateId="end-date"
        focusedInput={focusedInput}
        isOutsideRange={(day) => false}
        navNext="›"
        navPrev="‹"
        numberOfMonths={1}
        onDatesChange={({ startDate, endDate }) => selectDates(startDate, endDate, null)}
        onFocusChange={(focusedInput) => setFocusedInput(focusedInput)}
        phrases={phrases}
        renderCalendarInfo={renderFilterOptions}
        startDate={beginDate}
        startDateAriaLabel="Pick a start date to filter your student reports."
        startDateId="start-date"
      />
    </div>
  );
};

export default DateRangeFilter;
